"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.transfusionOccurredMessages = exports.TransfusionOccurred = void 0;
const schema_1 = require("../../../../../schema");
var TransfusionOccurred;
(function (TransfusionOccurred) {
    TransfusionOccurred["YES"] = "YES";
    TransfusionOccurred["NO"] = "NO";
})(TransfusionOccurred || (exports.TransfusionOccurred = TransfusionOccurred = {}));
exports.transfusionOccurredMessages = {
    [TransfusionOccurred.YES]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.transfusion.transfusionOccurred.YES",
        defaultMessage: "Igen"
    },
    [TransfusionOccurred.NO]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.transfusion.transfusionOccurred.NO",
        defaultMessage: "Nem"
    }
};
const transfusionOccurred = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(TransfusionOccurred.YES),
    schema_1.Schema.singleChoiceItem(TransfusionOccurred.NO)
]);
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ transfusionOccurred, comment })
    .interpretation({ vocab: "ktx", code: "transfusion" });
